// extracted by mini-css-extract-plugin
export default {"root":"ToggleableSection__root--ZHRoL","disabled":"ToggleableSection__disabled--lV7x3","toggle":"ToggleableSection__toggle--gQLbK","icon":"ToggleableSection__icon--sv2zd"};